import Controller from "./mainSidenav.controller";
import template from "./mainSidenav.html";

const mainSidenav = {
  template,
  controller: Controller,
  bindings: {
    sections: "<",
  },
};

export default mainSidenav;



// WEBPACK FOOTER //
// ./src/components/mainSidenav/mainSidenav.component.js